import { render, staticRenderFns } from "./ClientSetupView.vue?vue&type=template&id=25673ee0&scoped=true"
import script from "./ClientSetupView.vue?vue&type=script&lang=ts"
export * from "./ClientSetupView.vue?vue&type=script&lang=ts"
import style0 from "./ClientSetupView.vue?vue&type=style&index=0&id=25673ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25673ee0",
  null
  
)

export default component.exports